<div class="flex flex-column">
    <input type="text" id="matricula" pInputText [(ngModel)]="matricula" > 
    <button pButton pRipple type="button" label="Enviar" class="p-button-outlined w-full mt-3"
                icon="fa-solid fa-arrow-right-to-bracket" (click)="sendMatricula()"></button>
</div>